import { render, staticRenderFns } from "./LeftSubmenu.vue?vue&type=template&id=f7970900&"
import script from "./LeftSubmenu.vue?vue&type=script&lang=js&"
export * from "./LeftSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports